import React, { useState } from "react";
import { makeStyles, useTheme } from "@mui/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import useMediaQuery from "@mui/material/useMediaQuery";
import CircularProgress from "@mui/material/CircularProgress";

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    minWidth: 300,
  },
  textField: {
    marginTop: theme.spacing(2),
    width: "100%",
  },
}));

const EmailInvoiceDialog = (props) => {
  const { open, onClose, onSend, loading, error } = props;

  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleClose = () => {
    setEmail("");
    setEmailError("");
    onClose();
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (value && !validateEmail(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleSend = () => {
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      setEmailError("Email is required");
      return;
    }
    if (!validateEmail(trimmedEmail)) {
      setEmailError("Please enter a valid email address");
      return;
    }
    onSend(trimmedEmail);
  };

  const isButtonDisabled = !email.trim() || !!emailError || loading;

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="email-invoice-dialog-title"
    >
      <DialogTitle id="email-invoice-dialog-title">
        Email Invoice
      </DialogTitle>
      <DialogContent className={classes.content}>
        <DialogContentText>
          Enter the email address to send the invoice to.
        </DialogContentText>
        {error && (
          <DialogContentText color="error" style={{ marginTop: 8 }}>
            {error}
          </DialogContentText>
        )}
        <TextField
          className={classes.textField}
          label="Email Address"
          type="email"
          value={email}
          onChange={handleEmailChange}
          error={!!emailError}
          helperText={emailError}
          autoFocus
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" disabled={loading}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleSend}
          disabled={isButtonDisabled}
        >
          {loading ? <CircularProgress size={24} /> : "Send"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailInvoiceDialog;
